// Formatage des prix côté client, aligné sur le helper Rails price_tnd
// ("1 234,56 TND"). Intl avec style:"currency" rend "DT" pour la locale
// fr-TN : un même prix changeait donc d'unité selon qu'il venait du
// serveur ou d'un rendu JS, parfois au même endroit de la page.
export function formatTND(amount) {
  const num = typeof amount === "number" ? amount : parseFloat(amount)
  if (!Number.isFinite(num)) return "0,00 TND"

  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num)

  // Intl sépare les milliers par une espace fine insécable ; price_tnd
  // utilise une espace simple.
  return `${formatted.replace(/[  ]/g, " ")} TND`
}
